'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var ModalHeader = function ModalHeader(props) {
	var className = (0, _classnames2['default'])('Modal__header', props.className);
	var text = props.text ? _react2['default'].createElement(
		'h2',
		{ className: 'Modal__header__text' },
		props.text
	) : null;
	return _react2['default'].createElement(
		'div',
		_extends({}, props, { className: className }),
		text,
		props.children
	);
};

ModalHeader.propTypes = {
	children: _propTypes2['default'].node,
	className: _propTypes2['default'].string,
	text: _propTypes2['default'].string
};

module.exports = ModalHeader;